define((require) => {
    "use strict";

    const _                     = require("underscore");
    const AbstractWidgetModel   = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const SceneNavigationAction = require("shared/ui/experience/action/sceneNavigation/SceneNavigationAction");

    // Need to require file for Webpack to pick it up without compromising the image structure for the image widget.
    // Adding this as CSS will show arrows twice, thus we can import them as js.
    require("transparent-pixel.gif");
    require("image_default_next_scene.svg");
    require("image_default_previous_scene.svg");

    // Using a transparent gif pixel as default image because otherwise Chrome draws a border on
    // the image. The icon in the center of the placeholder is set using CSS.
    //   The default image icon used to be images/image_default.svg. That file will be kept for a
    // while to avoid empty image widgets in experiences that still have the old default image.
    const DEFAULT_IMAGE_URL = "images/transparent-pixel.gif";
    const DEFAULT_NEXT_URL  = "images/image_default_next_scene.svg";
    const DEFAULT_PREV_URL  = "images/image_default_previous_scene.svg";

    /**
     * Model for an image widget.
     *
     * @class ImageWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Image widget", {

        defaults: _.defaults({
            altText: null,
            borderRadius: 0, // px
            height: 0,
            imageId: null,
            originalImageHeight: 0, // px
            originalImageWidth: 0, // px
            supportsResize: false,
            src: null,
            type: "image",
            width: 0,
            crop: null,
            isDynamic: false
        }, AbstractWidgetModel.prototype.defaults),
        computed: _.extend({
            imageUrl: {
                deps: ["src", "action", "actions"],
                value(src, action, actions) {
                    // Return the image source if defined
                    if (src) {
                        return src;
                    }

                    let sceneNavigationAction;

                    // 'actions' has been deprecated, but we still need to be compatible...
                    if (actions.length) {
                        // If the widget has a next or previous scene action, default to an arrow
                        sceneNavigationAction = actions.find((model) => (model instanceof SceneNavigationAction));
                    }

                    if (action instanceof SceneNavigationAction) {
                        sceneNavigationAction = action;
                    }

                    if (sceneNavigationAction) {
                        if (sceneNavigationAction.get("target") === "next") {
                            return DEFAULT_NEXT_URL;
                        }

                        if (sceneNavigationAction.get("target") === "previous") {
                            return DEFAULT_PREV_URL;
                        }
                    }

                    return DEFAULT_IMAGE_URL;
                }
            }
        }, AbstractWidgetModel.prototype.computed),

        hasImage() {
            return this.has("src");
        },

        /**
         * Whether *this* widget contains a valid original size of the associated image, if any.
         *
         * @return {Boolean} <tt>true</tt> if *this* widget contains a valid original size of the associated image, <tt>false</tt> otherwise.
         */
        containsImageSize() {
            return this.get("originalImageWidth") > 0 && this.get("originalImageHeight") > 0;
        }

    }, {
        DEFAULT_IMAGE_URL
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/imageWidget/ImageWidgetModel.js